<template>
    <div class="task-module">
        <img class="g-img-gap" src="@/assets/images/bg/bg_img_2@3x.jpg" alt="" />
        <div class="task-module-list">
            <ModuleTitle title="任务列表"></ModuleTitle>
            <div class="list-item" v-for="item in store.indexData.task" :key="item.key">
                <div class="list-item-top tast-img-list g-flex-start-center" @click.stop="onTaskClick(item)">
                    <div class="list-item-left">
                        <p class="list-item-count">{{ item.spiritual_power_value }}</p>
                        <p class="list-item-text">灵力值</p>
                    </div>
                    <div class="list-item-desc">
                        <p class="list-item-title">{{ item.name }}</p>
                        <p class="list-item-tip">{{ item.second_title }}</p>
                    </div>
                    <div class="list-item-btn button-2 g-flex-center-center" v-if="item.key === 'reading_60'">{{ item.button }}</div>
                    <div v-else class="list-item-btn button-2 g-flex-center-center" :class="item.status === '2' ? 'button-4' : item.status === '1' ? 'button-5' : 'button-2'">{{ item.button }}</div>
                </div>
                <!-- 每日阅读时长 -->
                <div class="list-item-bottom curtain-img-2 g-flex-start-center" v-if="item.key === 'reading_60'">
                    <div class="list-item-power" @click.stop="onTaskBottomClick(item)">
                        <p class="list-item-power-count">{{ item.claim_spiritual_power_value }}</p>
                        <p class="list-item-power-text">灵力值</p>
                        <p class="list-item-power-btn button-4 g-flex-center-center" v-if="item.status === '2'">领取</p>
                    </div>
                    <div class="list-item-progress g-flex-1">
                        <div class="list-item-progress-desc g-flex-start-center">
                            <p class="list-item-progress-title">当前时长</p>
                            <p class="list-item-progress-text">{{ store.indexData.user_info.read_time }}/60</p>
                        </div>
                        <div class="list-item-progress-bar">
                            <div class="list-item-progress-bar-active" :style="{ width: `${store.indexData.user_info.readPercent}%` }"></div>
                        </div>
                    </div>
                </div>
                <!-- 累计阅读 -->
                <div class="list-item-bottom list-item-bottom2 curtain-img-1" v-if="item.key === 'accumulate_read'">
                    <div class="list-item-progress2 g-flex-start-center">
                        <template v-for="(extend, index) in item.extend">
                            <div class="progress2-line" :style="{ width: readExtend[index].percent + '%' }" :key="extend.key">
                                <div class="progress2-line-active" :style="{ width: readExtend[index].dayPercent + '%' }"></div>
                            </div>
                            <div class="progress2-dot" :class="{ 'progress2-dot-received': extend.status === '1', 'progress2-dot-active': readExtend[index].dayPercent === 100 }" :key="extend.key">
                                <div class="progress2-dot-top">
                                    <p class="progress2-dot-top-count">{{ extend.spiritual_power_value }}</p>
                                    <p class="progress2-dot-top-text">灵力值</p>
                                </div>
                                <div class="progress2-dot-bottom">
                                    <span v-if="readExtend[index].showCurrentDay">{{ store.indexData.user_info.accumulate_read_day }}/</span>{{ readExtend[index].day }}天
                                    <div class="progress2-dot-bottom-icon icon-finish-task" v-if="extend.status === '1'"></div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <p class="list-item-progress2-tip">*今日阅读时长{{ store.indexData.user_info.read_time_really }}分钟</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { getCurrentInstance, ref, watch } from 'vue';
import ModuleTitle from '../module-title/index.vue';
import { useStore } from '../../store';
import { apiFinishTask } from '@/http/api';
import { schemaSingle, openLogin, jsbReportV3, schemaSupportMap } from '@q-front-npm/jsbridge';
const store = useStore();
const instance = getCurrentInstance();
const emits = defineEmits(['share', 'refresh']);

const saClick = (title: string) => {
    jsbReportV3('moon_btn_button_click', { btn_wenan: '领取', type: title, });
};
let isClicking = false;
const onFinishTask = async(item: Record<string, any>, toDone = false) => {
    if (isClicking) {
        return;
    }
    isClicking = true;
    try {
        const params = {
            activityKey: store.indexData.activity_key,
            taskKey: item.key,
            toStatus: toDone ? '1' : '2', // 1 是待领取任务变已完成, 2 是未完成任务变待领取
        };
        const res = await apiFinishTask(params);
        if (toDone) {
            let str = `获得灵力值${item.claim_spiritual_power_value}`;
            if (item.key === 'sign_in') {
                str = `任务完成，${str}`;
            }
            instance!.proxy.$toast(str);
            saClick(item.name);
        }
        emits('refresh');
    } finally {
        isClicking = false;
    }
};
const onReceiveRead = async(extend: Record<string, any>[], name: string) => {
    const apiList = [];
    const powerList: number[] = [];
    for (const item of extend) {
        if (item.status !== '2') {
            continue;
        }
        const params = {
            activityKey: store.indexData.activity_key,
            taskKey: item.key,
            toStatus: '1', // 1 是待领取任务变已完成, 2 是未完成任务变待领取
        };
        apiList.push(apiFinishTask(params));
        powerList.push(+item.spiritual_power_value);
    }
    const resList = await Promise.allSettled(apiList);
    let totalPower = 0;
    resList.forEach((item, index) => {
        if (item.status === 'fulfilled') {
            totalPower += powerList[index];
        }
    });
    instance!.proxy.$toast(`获得灵力值${totalPower}`);
    saClick(name);
    emits('refresh');
};
let shareTaskData: Record<string, any> = {};
const btnSchemaIsSupport = (key: string) => {
    if (key === 'post_topic') {
        return schemaSupportMap.image_text_post_publish;
    }
    if (['comment', 'essence'].includes(key)) {
        return schemaSupportMap.book_friend_circle;
    }
    return true;
};
const onTaskClick = (item: Record<string, any>, actionType = '') => {
    // status 0 未完成 1 已完成 2 可领取
    const { status, key, button_url, extend, } = item;
    const needLogin = (store.indexData.isBlankUser && key !== 'share') || (!store.indexData.isLogin && key === 'post_topic');
    if (needLogin) {
        openLogin();
        return;
    }
    const isSupport = btnSchemaIsSupport(key);
    if (!isSupport) {
        instance!.proxy.$toast('请升级至最新版本');
        return;
    }
    const isFinished = status === '1';
    const isCanReceive = key === 'reading_60' ? actionType === 'receive' && status === '2' : status === '2';
    switch (key) {
        case 'sign_in':
            if (isFinished) {
                return;
            }
            onFinishTask(item, true);
            return;
        case 'share':
            if (isCanReceive) {
                onFinishTask(item, true);
                return;
            }
            emits('share');
            shareTaskData = item;
            return;
    }
    if (isCanReceive) {
        // 累计阅读若有多个可领取，需多次执行领取
        if (key === 'accumulate_read') {
            onReceiveRead(extend, item.name);
            return;
        }
        onFinishTask(item, true);
        return;
    }
    if (button_url) {
        schemaSingle.openSchema(button_url);
    }
};
const onTaskBottomClick = (item: Record<string, any>) => {
    if (item.status === '2') {
        onTaskClick(item, 'receive');
    }
};
const onShareSuccess = () => {
    console.log('-- onShareSuccess', shareTaskData.status);
    if (shareTaskData.status === '1') {
        return;
    }
    onFinishTask(shareTaskData);
};
const readExtend = ref([
    {
        percent: 20,
        day: 3,
        dayPercent: 0,
        showCurrentDay: false,
    },
    {
        percent: 30,
        day: 7,
        dayPercent: 0,
        showCurrentDay: false,
    },
    {
        percent: 50,
        day: 14,
        dayPercent: 0,
        showCurrentDay: false,
    }
]);

const getReadExtend = () => {
    const day = store.indexData.user_info.accumulate_read_day;
    let prevDay = 0;
    for (const item of readExtend.value) {
        let dayPercent = (day - prevDay) / (item.day - prevDay);
        dayPercent = dayPercent > 1 ? 1 : dayPercent;
        item.dayPercent = dayPercent * 100;
        prevDay = item.day;
        if (day <= item.day) {
            item.showCurrentDay = item.dayPercent !== 100;
            return;
        }
    }
};
watch(
    () => store.indexData.user_info.accumulate_read_day,
    () => {
        getReadExtend();
    }
);
getReadExtend();
defineExpose({
    onShareSuccess,
});
</script>
<style lang="scss" scoped>
.task-module {
    position: relative;
    &-list {
        position: absolute;
        top: 80px;
        left: 0;
        right: 0;
        bottom: 0;
    }
}
.list-item {
    width: 648px;
    margin: 0 auto 20px;
    &-top {
        height: 132px;
        position: relative;
        z-index: 2;
        padding-right: 24px;
    }
    &-bottom {
        margin: -10px 0 0 32px;
        padding-bottom: 30px;
        margin-bottom: -8px;
    }
    &-left {
        width: 140px;
        text-align: center;
        flex-shrink: 0;
    }
    &-count {
        font-weight: bold;
        font-size: 46px;
        color: #ecf6ff;
        line-height: 66px;
    }
    &-text {
        margin-top: -10px;
        font-weight: bold;
        font-size: 20px;
        color: rgba(236, 246, 255, 0.7);
        line-height: 30px;
    }
    &-desc {
        margin-left: 18px;
    }
    &-title {
        font-weight: bold;
        font-size: 32px;
        color: #2a3e74;
        line-height: 46px;
    }
    &-tip {
        margin-top: 8px;
        font-size: 24px;
        color: rgba(42, 62, 116, 0.7);
        line-height: 1;
        font-family: '黑体';
    }

    &-btn {
        margin-left: auto;
        font-weight: bold;
        font-size: 24px;
        color: #3a2a1e;
        line-height: 1;
        text-align: center;
        flex-shrink: 0;

        &.button-5 {
            color: #75777e;
        }
    }

    &-power {
        padding-top: 40px;
        text-align: center;
        width: 185px;
        height: 176px;
        &-count {
            font-weight: bold;
            font-size: 36px;
            color: #473ab3;
            line-height: 52px;
        }
        &-text {
            margin-top: -12px;
            font-weight: bold;
            font-size: 20px;
            color: rgba(33, 37, 182, 0.6);
            line-height: 30px;
        }
        &-btn {
            font-weight: bold;
            font-size: 31px;
            color: #1e243a;
            line-height: 1;
            margin: 4px auto 0;
            transform: scale(0.65);
            transform-origin: top center;
        }
    }

    &-progress {
        padding-right: 40px;
        &-title {
            font-weight: bold;
            font-size: 24px;
            color: #2a3e74;
            line-height: 52px;
        }
        &-text {
            margin-left: auto;
            font-size: 26px;
            color: #7486a1;
            line-height: 52px;
        }

        &-bar {
            width: 100%;
            height: 8px;
            border-radius: 8px;
            background: #9db5db;
            position: relative;

            &-active {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                border-radius: 8px;
                background: linear-gradient(135deg, #faa741 0%, #fbcb78 100%);
                &::after {
                    content: '';
                    position: absolute;
                    top: -4px;
                    right: -4px;
                    width: 12px;
                    height: 12px;
                    background: #fbc772;
                    border: 2px solid #ffffff;
                    border-radius: 50%;
                }
            }
        }
    }
    &-bottom2 {
        padding: 100px 60px 0 44px;
    }
    &-progress2 {
        width: 100%;
        height: 8px;
        border-radius: 8px;
        position: relative;
        &-tip {
            text-align: center;
            margin-top: 50px;
            font-size: 20px;
            color: rgba(116, 134, 161, 0.75);
        }
    }
    .progress2-line {
        background: #9db5db;
        height: 100%;
        border-radius: 8px;
        position: relative;
        &-active {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            border-radius: 8px;
            background: linear-gradient(135deg, #faa741 0%, #fbcb78 100%);
        }
    }
    .progress2-dot {
        width: 16px;
        height: 16px;
        background: #9db5db;
        border: 2px solid #9db5db;
        border-radius: 50%;
        margin: 0 4px;
        flex-shrink: 0;
        position: relative;
        &-active {
            background: #fbc772;
            border: 2px solid #ffffff;
        }
        &-received {
            opacity: 0.6;
        }
        &-top {
            position: absolute;
            bottom: 28px;
            left: -40px;
            width: 96px;
            text-align: center;
            font-weight: bold;
            color: #354995;
            line-height: 1;

            &-count {
                font-size: 26px;
            }
            &-text {
                font-size: 18px;
            }
        }
        &-bottom {
            position: absolute;
            top: 18px;
            left: -40px;
            width: 96px;
            text-align: center;
            font-weight: bold;
            font-size: 20px;
            color: #7486a1;
            line-height: 30px;

            &-icon {
                position: absolute;
                right: 24px;
                top: 10px;
            }
        }
    }
}
</style>
